import "../sass/moj-blocks.scss";

import Accordion from "./functions/accordion";
import QuickExit from "./functions/quick-exit";
import PageActions from "./functions/page-actions";
import Embellishment from "./functions/embellishment";
import TableOfContents from "./functions/table-of-contents";
import Glossary from "./functions/glossary";
import Wayfinder from "./functions/wayfinder";
import Sidebar from "./functions/sidebar";
import Video from "./functions/video";
import AlternativeFormats from "./functions/alt-formats";

document.addEventListener(
  "DOMContentLoaded",
  () => {
    Accordion();
    QuickExit();
    PageActions();
    Embellishment();
    TableOfContents();
    Glossary();
    Wayfinder();
    Video();
    Sidebar();
    AlternativeFormats();

    setTimeout(() => {
      // wait till animations are finished and setTimeouts ran
      document.body.classList.add("mjb-ready");
    }, 300);

    // write a css var of --total-header-height of
    // - '#enviroBanner' height if it exists
    // - plus .header
    // - plus .toolbar
    // plus moj-breadcrumbs
    const writeHeaderHeight = () => {
      const enviroBanner = document.querySelector("#enviroBanner");
      const header = document.querySelector(".header-nav");
      const toolbar = document.querySelector(".toolbar");
      const breadcrumbs = document.querySelector(".moj-breadcrumbs");
      let totalHeaderHeight = 0;

      if (enviroBanner) {
        totalHeaderHeight += enviroBanner.offsetHeight;
      }
      if (header) {
        totalHeaderHeight += header.offsetHeight;
      }
      if (toolbar) {
        totalHeaderHeight += toolbar.offsetHeight;
      }
      if (breadcrumbs) {
        totalHeaderHeight += breadcrumbs.offsetHeight;
      }

      // if .quick-exit is on the page and not .quick-exit--minimised then add that height
      const quickExit = document.querySelector(".quick-exit");

      if (quickExit && !quickExit.classList.contains("quick-exit--minimised")) {
        totalHeaderHeight += quickExit.offsetHeight;
      }

      document.documentElement.style.setProperty(
        "--total-header-height",
        `${totalHeaderHeight}px`
      );
    };

    writeHeaderHeight();

    // re-calculate the header height on resize, debounced
    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        writeHeaderHeight();
      }, 250);
    });
  },
  {
    once: true,
  }
);
